/**
 * SessionStorage操作工具
 */

/**
 * 获取sessionStorage中的数据
 * @param key 键名
 * @returns 存储的值
 */
export const getSession = (key: string): string | null => {
  if (typeof window !== 'undefined') {
    return sessionStorage.getItem(key)
  }
  return null
}

/**
 * 设置sessionStorage中的数据
 * @param key 键名
 * @param val 值
 */
export const setSession = (key: string, val: string | object): void => {
  if (typeof window !== 'undefined') {
    const value = typeof val === 'object' ? JSON.stringify(val) : val
    sessionStorage.setItem(key, value)
  }
}

/**
 * 删除sessionStorage中的数据
 * @param key 键名
 */
export const removeSession = (key: string): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(key)
  }
}

/**
 * 清空sessionStorage
 */
export const clearSession = (): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.clear()
  }
}

/**
 * LocalStorage操作工具
 */

/**
 * 获取localStorage中的数据
 * @param key 键名
 * @returns 存储的值
 */
export const getLocal = (key: string): string | null => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(key)
  }
  return null
}

/**
 * 设置localStorage中的数据
 * @param key 键名
 * @param val 值
 */
export const setLocal = (key: string, val: string | object): void => {
  if (typeof window !== 'undefined') {
    const value = typeof val === 'object' ? JSON.stringify(val) : val
    localStorage.setItem(key, value)
  }
}

/**
 * 删除localStorage中的数据
 * @param key 键名
 */
export const removeLocal = (key: string): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(key)
  }
}

/**
 * 清空localStorage
 */
export const clearLocal = (): void => {
  if (typeof window !== 'undefined') {
    localStorage.clear()
  }
}

/**
 * 获取用户showName
 * @returns 用户showName
 */
export const getUserShowName = (): string | null => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('userShowName')
  }
  return null
}

/**
 * 设置用户showName
 * @param showName 用户showName
 */
export const setUserShowName = (showName: string): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('userShowName', showName)
  }
}

/**
 * 删除用户showName
 */
export const removeUserShowName = (): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('userShowName')
  }
} 

/**
 * 获取用户信息
 * @returns 用户showName
 */
export type StoredUserInfo = {
  id?: string | number
  name?: string
  phone?: string
  email?: string
  [key: string]: unknown
} | null

export const getUserInfoFromSessionStorage = (): StoredUserInfo => {
  if (typeof window !== 'undefined') {
    try {
      const raw = localStorage.getItem('userInfo')
      if (!raw) return null
      const parsed = JSON.parse(raw)
      return parsed as NonNullable<StoredUserInfo>
    } catch (e) {
      return null
    }
  }
  return null
}

/**
 * 设置用户信息
 * @param userInfo 用户信息
 */
export const setUserInfo = (userInfo: object | string): void => {
  if (typeof window !== 'undefined') {
    const value = typeof userInfo === 'string' ? userInfo : JSON.stringify(userInfo)
    localStorage.setItem('userInfo', value)
  }
}

/**
 * 删除用户信息
 */
export const removeUserInfo = (): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('userInfo')
  }
} 